import React from 'react';
import { Grid, Typography, Paper, Box, Divider } from '@mui/material';
import MetricCard from '../components/Dashboard/MetricCard';
import ChartCard from '../components/Dashboard/ChartCard';
import InsightCard from '../components/Analytics/InsightCard';
import { 
  mockKeyMetrics, 
  mockFinancialData, 
  mockFinancialInsights, 
  mockRecentActivity 
} from '../data/mockData';

const Dashboard: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Financial Dashboard
      </Typography>
      
      {/* Key Metrics */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {mockKeyMetrics.map((metric) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={metric.id}>
            <MetricCard 
              title={metric.name} 
              value={metric.value} 
              change={metric.change} 
              positive={metric.positive} 
            />
          </Grid>
        ))}
      </Grid>
      
      {/* Charts */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={8}>
          <ChartCard 
            title="Revenue Trends (Monthly)" 
            chartType="line" 
            data={mockFinancialData.revenue} 
            height={300}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ChartCard 
            title="Expenses by Category" 
            chartType="pie" 
            data={mockFinancialData.expenses} 
            height={300}
          />
        </Grid>
      </Grid>
      
      <Grid container spacing={3}>
        {/* AI Insights */}
        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom>
            AI-Powered Insights
          </Typography>
          <Grid container spacing={2}>
            {mockFinancialInsights.slice(0, 3).map((insight) => (
              <Grid item xs={12} key={insight.id}>
                <InsightCard 
                  title={insight.title} 
                  description={insight.description} 
                  impact={insight.impact as 'High' | 'Medium' | 'Low'} 
                  category={insight.category} 
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        
        {/* Recent Activity */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h5" gutterBottom>
              Recent Activity
            </Typography>
            {mockRecentActivity.map((activity, index) => (
              <React.Fragment key={activity.id}>
                <Box sx={{ py: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                      {activity.action}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {new Date(activity.timestamp).toLocaleString()}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {activity.description}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    by {activity.user}
                  </Typography>
                </Box>
                {index < mockRecentActivity.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
